import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-downgrade-warning-item',
  template: `
    <div class="flex items-center night" style="gap: 12px">
      <img src="/assets/iconography/warning.svg" alt="Warning" />
      <div class="flex flex-col" style="gap: 4px">
        <strong><ng-content select="[title]"></ng-content></strong>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DowngradeWarningItemComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }
}
